var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.392,5.977c-.188-.188-.441-.293-.707-.293s-.52.105-.707.293l-3.272,3.272c-.391.39-.391,1.023,0,1.414s1.023.391,1.414,0l1.565-1.565v8.218c0,.552.447,1,1,1s1-.448,1-1v-8.218l1.564,1.565c.195.195.451.293.707.293s.512-.098.707-.293c.391-.39.391-1.023,0-1.414l-3.271-3.272Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.295,13.337c-.391-.391-1.023-.391-1.414,0l-1.565,1.565V6.684c0-.552-.447-1-1-1s-1,.448-1,1v8.218l-1.564-1.565c-.391-.391-1.023-.391-1.414,0-.391.39-.391,1.023,0,1.414l3.271,3.272c.188.188.441.293.707.293s.52-.105.707-.293l3.272-3.272c.391-.39.391-1.023,0-1.414Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSwitch);
export default __webpack_public_path__ + "static/media/map-switch.0149b62f6e7b1e74d9ebf075a9b2f2fa.svg";
export { ForwardRef as ReactComponent };